var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"client-header"},[_c('img',{attrs:{"src":"images/kevi-positivo-retina.png","alt":""}}),_vm._v(" "),_c('a',{staticClass:"logout",on:{"click":function($event){$event.preventDefault();return _vm.$emit('logout')}}},[_vm._v("Sair")]),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.client.firstname))])])
}
var staticRenderFns = []

export { render, staticRenderFns }